import { getSession, setAuthCheckFailed, useGetAllProfileQuery } from '@onesource/services';
import type { ReactNode } from 'react';

type TAuthProviderProps = {
  children: ReactNode;
};

// A request that got an HTTP response (401, 403, 500, ...) reached the server —
// that's an auth/server failure, not a connectivity failure. Only a request
// that never got a response (timeout, DNS failure, offline, CORS) is a
// "can't connect" case that should show the connection-failed dialog.
const isNetworkError = (error: unknown): boolean => {
  return !!error && typeof error === 'object' && !('response' in error);
};

export const ProfileInfoProvider = (params: TAuthProviderProps) => {
  const { children } = params;
  const token = getSession();

  const { isError, error } = useGetAllProfileQuery({ token });

  if (isError && isNetworkError(error)) {
    setAuthCheckFailed();
  }

  return children;
};
